var React = require('react');

function Plug (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"plug-alt"),React.createElement("path",{"d":"M38.7,22.3l-1.5-1.5,4.5-4.5a1.9799,1.9799,0,0,0-2.8-2.8L34.4,18l-4.2-4.2,4.5-4.5a1.9799,1.9799,0,1,0-2.8-2.8L27.4,11,25.9,9.5a1.872,1.872,0,0,0-2.6,0L18.8,14h0a10.79388,10.79388,0,0,0-1.7,13L7.7,36l4.2,4.2L21,31.1a11.05409,11.05409,0,0,0,13-1.7h0l4.5-4.5A1.72157,1.72157,0,0,0,38.7,22.3Z","key":1})]);
}

Plug.displayName = "Plug";

Plug.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = Plug;

Plug.default = Plug;



// WEBPACK FOOTER //
// ./node_modules/pui-css-iconography/svgs/plug.svg